"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSrSubmit = exports.buildPageView = void 0;
const constants_1 = require("./constants");
/**
 * Searches through attached contexts for a specific schema, extracts field value
 * @param data list of attached contexts from the Snowplow event payload
 * @param schemaUri specific schema to search for
 * @param field specific field from the schema to grab
 */
const searchContexts = (data, schemaUri, field) => {
    var _a;
    const contexts = data.filter((context) => { var _a; return (_a = context.schema) === null || _a === void 0 ? void 0 : _a.includes(schemaUri); });
    if (contexts.length < 1) {
        return undefined;
    }
    return (_a = contexts[0].data[field]) !== null && _a !== void 0 ? _a : undefined;
};
/**
 * Returns the formatted query params, removing the leading ? if present
 * @param queryParams
 */
const getFormattedQueryParams = (queryParams) => {
    if (queryParams.startsWith('?')) {
        return queryParams.substring(1);
    }
    return queryParams;
};
/**
 * Builds the GTM Payload for the Snowplow page_view event. Returns null if the URL cannot be retrieved
 * @param payload Snowplow event payload that passes through the plugin
 */
const buildPageView = (payload) => {
    var _a, _b;
    const parsedContexts = JSON.parse((_a = payload.co) !== null && _a !== void 0 ? _a : '{}').data;
    const url = (_b = payload.url) !== null && _b !== void 0 ? _b : window.location.href;
    // Do not build a payload and send the event if the URL is missing
    if (url === undefined || url === null || url.length === 0) {
        return null;
    }
    return {
        event: 'Page View',
        brand: searchContexts(parsedContexts, constants_1.BRAND_ATTRIBUTES_SCHEMA_SEARCH, 'name'),
        host: window.location.hostname,
        name: searchContexts(parsedContexts, constants_1.PAGE_ATTRIBUTES_SCHEMA_SEARCH, 'name'),
        path: window.location.pathname,
        search: getFormattedQueryParams(window.location.search),
        url,
    };
};
exports.buildPageView = buildPageView;
/**
 * Builds the GTM Payload for the Snowplow sr_submit event
 * @param payload Snowplow event payload that passes through the plugin
 */
const buildSrSubmit = (payload) => {
    var _a, _b, _c;
    const eventSchema = JSON.parse((_a = payload.ue_pr) !== null && _a !== void 0 ? _a : '{}').data;
    return {
        event: 'SR Submit',
        sr_id: (_b = eventSchema.data) === null || _b === void 0 ? void 0 : _b.sr_id,
        sr_uuid: (_c = eventSchema.data) === null || _c === void 0 ? void 0 : _c.sr_uuid,
    };
};
exports.buildSrSubmit = buildSrSubmit;
//# sourceMappingURL=data:application/json;base64,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


// WEBPACK FOOTER //
// ../../../../../src/plugins/custom/googleTagManagerDataInjection/builders.ts